// Public bylines and verified founder profiles.

export type Author = {
  id: string
  name: string
  role: string
  avatar: string
  /** Public profile URLs for Person JSON-LD `sameAs`. Omit when unverified. */
  sameAs?: Array<string>
}

export const authors: Record<string, Author> = {
  'brew-team': {
    id: 'brew-team',
    name: 'Brew Team',
    role: 'Brew editorial team',
    avatar: '/logo/circle_orange.png',
  },
  'philip-sorensen': {
    id: 'philip-sorensen',
    name: 'Philip Sørensen',
    role: 'Co-founder & CEO, Brew',
    avatar: '/people/philip_sorensen.png',
    sameAs: ['https://www.linkedin.com/in/philipsorensen'],
  },
  'thomas-park': {
    id: 'thomas-park',
    name: 'Thomas Park',
    role: 'Co-founder & CTO, Brew',
    avatar: '/people/thomas_park.jpeg',
    sameAs: ['https://www.linkedin.com/in/thomasjunseopark'],
  },
}

// Helper function to get author by name (case-insensitive, handles spaces)
export function getAuthorByName(name: string | undefined): Author | undefined {
  if (!name) {
    return
  }

  // Convert name to id format (lowercase, spaces to hyphens)
  const nameId = name.toLowerCase().replace(/\s+/g, '-')

  // Try direct lookup first
  if (authors[nameId]) {
    return authors[nameId]
  }

  // Try matching by name
  return Object.values(authors).find(
    (author) => author.name.toLowerCase() === name.toLowerCase()
  )
}
